import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as screen1 from "./style.module.scss";

import { HeaderWithNav } from "../../../../HeaderWithNav"
import navData from "./navData.json";

export const Screen1 = () => {
  return (
    <header className={screen1.header}>
      <div className="container">

        <HeaderWithNav
          data={navData}
          buttonText={"Купить курс"}
          noContainer={true}
        />

        <div className={screen1.header__content}>
          <div className={screen1.header__main}>
            <h1 className={screen1.header__title}>Курс «Как научить ребёнка читать быстро и с умом»</h1>
            <p className={screen1.header__description}>Курс для занятий с детьми младшего школьного возраста, который поможет
              вам научить ребёнка:</p>
            <ul className={screen1.header__list}>
              <li className={screen1.header__listItem}>читать в 2 раза быстрее;</li>
              <li className={screen1.header__listItem}>понимать и запоминать текстовую информацию;</li>
              <li className={screen1.header__listItem}>пересказывать прочитанное.</li>
            </ul>
            <a href="#user-action" className={main.mainBtn}>Купить курс</a>
          </div>
          <div className={screen1.header__img}>
            <img
              src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/header-img.png"
              alt={""}
            />
          </div>
        </div>

      </div>
    </header>
  );
};
